module.exports = __webpack_public_path__ + "img/Millionaire-6.019a0731.gif";